/**
 * Normalize WebSocket / notification payloads into a single pending-request shape.
 * @returns {object|null} request row or null if not applicable
 */

export function normalizeChatRequestFromWebSocket(message) {
  if (!message) return null;

  if (message.notificationType === 'chat_request' && message.action === 'created') {
    const metadata = message.metadata || message.data || {};
    const chatSessionId = metadata.chatSessionId || message.chatSessionId;
    if (!chatSessionId) return null;
    return {
      chatSessionId,
      guestName: metadata.guestName || message.guestName,
      email: metadata.email || message.email,
      subject: metadata.subject || message.subject,
      ticketNumber: metadata.ticketNumber || message.ticketNumber,
      status: metadata.status || message.status || 'PENDING_ACCEPTANCE',
      createdOn: metadata.createdOn || message.createdOn,
      timestamp: message.timestamp || Date.now()
    };
  }

  if (message.type === 'CHAT_SESSION_REQUEST') {
    const d = message.data || {};
    const chatSessionId = d.chatSessionId;
    if (!chatSessionId) return null;
    return {
      chatSessionId,
      guestName: d.guestName,
      email: d.email,
      subject: d.subject,
      ticketNumber: d.ticketNumber,
      status: d.status,
      createdOn: d.createdOn,
      timestamp: message.timestamp || Date.now()
    };
  }

  return null;
}

export function getChatSessionIdFromAcceptedMessage(message) {
  if (!message) return null;
  const nt = message.notificationType || message.type;
  if (nt === 'chat_accepted') {
    const metadata = message.metadata || message.data || {};
    return metadata.chatSessionId || message.chatSessionId || null;
  }
  if (message.type === 'CHAT_SESSION_ACCEPTED') {
    return message.data?.chatSessionId || null;
  }
  return null;
}

/** Payload for agents when another user accepts a chat (WebSocket / bell). */
export function parseChatAcceptedFromMessage(message) {
  if (!message) return null;
  const nt = message.notificationType || message.type;
  if (nt !== 'chat_accepted') return null;
  const meta = message.metadata || message.data || {};
  const chatSessionId = meta.chatSessionId || message.chatSessionId;
  if (!chatSessionId) return null;
  return {
    chatSessionId,
    acceptedByAgentName: meta.acceptedByAgentName || null,
    assignedAgentId: meta.assignedAgentId != null ? meta.assignedAgentId : null,
    status: meta.status || null,
    guestName: meta.guestName || null,
    subject: meta.subject || null,
    ticketNumber: meta.ticketNumber || null
  };
}

/** NotificationContext / FCM shape → pending row */
export function normalizeChatRequestFromNotification(notification) {
  if (!notification) return null;
  const isChat =
    notification.notificationType === 'chat_request' || notification.type === 'chat_request';
  if (!isChat) return null;
  if (notification.action === 'updated' || notification.action === 'dismissed') {
    return null;
  }
  const metadata = notification.metadata || notification.data || {};
  const chatSessionId =
    metadata.chatSessionId ||
    notification.data?.chatSessionId ||
    notification.chatSessionId;
  if (!chatSessionId) return null;
  return {
    chatSessionId,
    guestName: metadata.guestName || notification.data?.guestName,
    email: metadata.email,
    subject: metadata.subject,
    ticketNumber: metadata.ticketNumber,
    status: metadata.status || 'PENDING_ACCEPTANCE',
    createdOn: metadata.createdOn || notification.createdAt,
    timestamp: Date.now()
  };
}

export function mapPendingApiRow(row) {
  if (!row?.chatSessionId) return null;
  return {
    chatSessionId: row.chatSessionId,
    guestName: row.guestName,
    email: row.email,
    subject: row.subject,
    ticketNumber: row.ticketNumber,
    status: row.status || 'PENDING_ACCEPTANCE',
    createdOn: row.createdOn,
    timestamp: Date.now()
  };
}
